













































import Vue from 'vue'
export default Vue.extend({
  name: 'AlarmHistoryFilter',
  props: {
    value: Object,
  },
  data() {
    return {
      optsClass: [
        { text: 'All', value: '' },
        { text: 'Warning', value: 'warning' },
        { text: 'Error', value: 'error' },
      ],
      optsLimit: [10, 25, 50, 100],
      timeRange: 0,
      currentPage: 1,
      filter: {
        class: '',
        start: 0,
        end: 0,
        text: '',
      },
    }
  },
  methods: {},
  watch: {
    timeRange: function(val: number[]) {
      this.filter.start = val[0]
      this.filter.end = val[1]
    },

    filter: {
      deep: true,
      handler: function() {
        this.$emit('input', this.filter)
      },
    },
  },

  created() {
    if (this.value != undefined) {
      this.filter = this.value
    }
  },
})
